<template>
  <div class="xscontainer jsjiesh">
    <div class="dsfsdfd">
      <div class="nnfrrtrrt">
        <el-page-header @back="goBack" content="直播详情">
        </el-page-header>
      </div>
      <table>
        <thead>
        </thead>
        <tbody>
        <tr>
          <td class="td_1">直播主题</td>
          <td class="td_2">{{currentObj.zhibobt}}</td>
        </tr>
        <tr>
          <td class="td_1">主题介绍</td>
          <td class="td_2">{{currentObj.zhibodescrib}}</td>
        </tr>
        <tr>
          <td class="td_1">直播讲师</td>
          <td class="td_2">{{currentObj.zhujiangren}}</td>
        </tr>
        <tr>
          <td class="td_1">讲师介绍</td>
          <td class="td_2">{{currentObj.zhujiangrenjieshao}}</td>
        </tr>
        <tr>
          <td class="td_1">直播时间</td>
          <td class="td_2">{{currentObj.zhibotime}}</td>
        </tr>
        <tr>
          <td class="td_1">直播方式</td>
          <td class="td_2">{{currentObj.zhibofangshi}}</td>
        </tr>
        <tr>
          <td class="td_1">直播链接</td>
          <td class="td_2 ljiecss" @click="gotozhibo(currentObj.lianjie)">{{currentObj.lianjie}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
      currentObj:{},
      fwcishu:0
    }
  },
  mounted() {
    this.currentObj = this.$route.query.item;
  },
  created() {
    this.currentObj = this.$route.query.item;
    this.tongji(this.currentObj.lianjie);
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    goBack(){
      this.$router.back();
    },
    gotozhibo(){
      window.open(this.currentObj.lianjie);
      // window.open("https://meeting.tencent.com/dm/pNwYA3rXxZzl");
    }
  }
}
</script>

<style  scoped>
.dsfsdfd{
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
.nnfrrtrrt{
  width: 100%;
}
.kknnvh{
  display: flex;
  justify-content: center;
}
.mkl{
  width: 100%;
  height: 2rem;
  background-color: #f5fafe;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:2rem;
}
.mybtn{
  width: 10%;
  height: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  border:1px solid #54abf1;
  background-color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  color: #54abf1;
}
.mybtn:hover{
  cursor: pointer;
  color: #ffffff;
  background-color: #54abf1;
}
.dkll{
  display: flex;
  gap: 2rem;
}
.zss{
  width: 30rem;
  height: 20rem;
}
.rkdk{
  display: flex;
  flex-direction: column;
  justify-content: end;
}
.knclks{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}
.cnnckd{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.nccsl{
  height: 1.5rem;
  line-height: 1.5rem;
  width: 6rem;
  background-color: #eeeded;
  text-align: center;
  font-weight: bold;
  font-size: 0.9rem;

}
.zitidax{
  height: 1.5rem;
  line-height: 1.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
}
.kklls{
  font-size: 0.9rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
  text-align: center;
}
.lllls{
  display: flex;
  flex-wrap: wrap;
}
.ddfg{
  font-weight: bold;
}
.el-form-item{
  margin-bottom: 2rem;
}

.td_1 {
  width: 30%;
  color: #4e83c5;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}

.td_2 {
  //color: #4e83c5;
  width: 70%;
  text-align: center;
  font-size: 14px;
}

/* 基础表格样式 */
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0 0 0;
  font-family: Arial, sans-serif;
}

/* 表头样式 */
th {
  background-color: #f2f2f2;
  color: #333;
  font-weight: bold;
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

/* 单元格样式 */
td {
  padding: 8px;
  border: 1px solid #ddd;
}

/* 隔行变色效果 */
tr:nth-child(even) {
  //background-color: #f9f9f9;
}

/* 鼠标悬停效果 */
tr:hover {
  //background-color: #f1f1f1;
}
.ljiecss{
  color:#0f7cf1;
}
.ljiecss:hover{
  cursor: pointer;
  text-decoration: underline;
}
</style>
